import { css } from '@emotion/css'

import { accessiblyHidden } from '@offerzen/pinata'

const styles = {
  card: css({
    width: '100%',
    height: 150,
  }),

  accessiblyHidden: css(accessiblyHidden),
}

export default styles
